module.exports = __webpack_public_path__ + "img/my-filters-anon.fed0260d.svg";